import { api } from "./client";

export interface PledgeProduct {
  id: number;
  name: string;
  yield: string;
  income: number | string;
  cycle: number;
  buy_limit: number;
  money: number | string;
  state: number;
  finish_times?: number;
  day?: number;
  hour?: number;
  minute?: number;
  second?: number;
}

export interface PledgeBalance {
  balance: number | string;
  coin: number | string;
  today_income?: number | string;
  positions?: PledgePosition[];
}

export interface FundIncome {
  buyAmount: number | string;
  profit: number | string;
}

export interface PledgePosition {
  id: number;
  pledge_id: number;
  name: string;
  yield: number | string;
  income: number | string;
  cycle: number;
  money: number | string;
  current_profit: number | string;
  expire_time: number;
  state: number;
  create_time: number;
  pay_func: number;
  create_time_r: string;
  expire_time_r: string;
  remaining_days: number;
  progress: number;
}

export const financeApi = {
  products: (type: 1 | 2) =>
    api.post<PledgeProduct[]>(
      "/api/v2/pledge/list",
      type === 2 ? { type: 2 } : undefined,
    ),
  balance: (type: 1 | 2 = 1) =>
    api.post<PledgeBalance>("/api/v2/pledge/balance", { type }),
  fundIncome: () => api.post<FundIncome>("/api/v2/fund/income"),
  buy: (pledgeId: number) => api.post("/api/v2/user/pledge", { pledgeId }),
};
